export const OtpErrorMessage = ({ message }: { message: string }) => {
  return (
    <span role="alert" className="typography-text-xs text-red-500">
      {message}
    </span>
  );
};
